import { type FC, useId } from 'react'
import { useIntl } from 'react-intl'

import { IconCaretDown } from '@redteclab/icons'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { type ContactFormState } from '../../../contact-form'
import { type OpenableControls } from '../../../generic-hooks'

import { useDirectFormDialogContext } from './DirectContactFormDialogContext'

export const DirectContactFormProductsInputField: FC<{
  formState: ContactFormState
  productSelectionModalControls: OpenableControls
}> = ({ formState, productSelectionModalControls }) => {
  const orderItemNames = useId()
  const { productList, setOrderSelectionDialogTitle } =
    useDirectFormDialogContext()
  const intl = useIntl()

  const selectedItemNames = [...productList]
    .map((obj) => obj.itemName)
    .join(', ')

  return (
    <FormControl
      className="mb-2 w-full cursor-pointer"
      error={!formState.model.validator.isPropertyValid('productCode')}
      onClick={(event) => {
        event.preventDefault()
        setOrderSelectionDialogTitle(
          intl.formatMessage({
            id: 'direct.contact.form.select.product.title',
          }),
        )
        productSelectionModalControls.handleOpen()
      }}
      required
      value={selectedItemNames}
    >
      <FormLabel className="text-dark-primary-max" htmlFor={orderItemNames}>
        {intl.formatMessage({
          id: 'direct.contact.form.product.names',
        })}
      </FormLabel>
      <Input
        className="caret-transparent"
        endAdornment={
          <IconCaretDown className="-mr-2 size-6 text-dark-brand" />
        }
        id={orderItemNames}
        slotProps={{
          input: {
            'data-qa-id': 'contact-form-product-names-logged-in',
            style: {
              cursor: 'pointer',
            },
          },
        }}
      />
      {formState.model.validator.getFirstErrorFor('productCode') && (
        <FormHelperText
          className="text-dark-error"
          data-qa-id="contact-form-product-name-logged-in-error-msg"
        >
          {formState.model.validator.getFirstErrorFor('productCode')}
        </FormHelperText>
      )}
    </FormControl>
  )
}
